import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ComercialDrawer from "../../../../../components/pet-beauty/CormercialDrawer";
import ComercialInterfaceHeader from "../../../../../components/comercial/ComercialInterfaceHeader";
import WorkingScaleSelector from "../../../../../components/comercial/WorkingScaleSelector";
import employeeApi from "../../../../../services/api/Employee";
import { IEmployee } from "../../../../../services/api/Employee/types";
import { getLocalStorageItem } from "../../../../../hooks/localStorageHooks";
import BackPageButton, {
  LeftMarginBackButton,
} from "../../../../../components/general/buttons/BackPageButton";
import { sharedStyles } from "../../../../../styles/shared";
import { SecondaryButton } from "../../../../../components/general/buttons/SecondaryButton";
import { PrimaryButton } from "../../../../../components/general/buttons/PrimaryButton";
import { useAuth } from "../../../../../context/AuthProvider/useAuth";
import { useTranslation } from "react-i18next";
import {IStore} from "@/services/api/Store/types";

const EditEmployee = () => {
  const { t } = useTranslation();


  const navigate = useNavigate();

  const selectedEmployee: IEmployee = getLocalStorageItem("selectedEmployee");

  const selectedStore: IStore = getLocalStorageItem("selectedStore");

  const auth = useAuth();

    const detectBestInterval = (emp: IEmployee) => {
        const allTimes = [
            ...(emp?.timeMonday || []),
            ...(emp?.timeTuesday || []),
            ...(emp?.timeWednesday || []),
            ...(emp?.timeThursday || []),
            ...(emp?.timeFriday || []),
            ...(emp?.timeSaturday || []),
            ...(emp?.timeSunday || []),
        ];
        if (allTimes.some((t) => t.endsWith(":15") || t.endsWith(":45"))) return 15;
        if (allTimes.some((t) => t.endsWith(":30"))) return 30;
        return 60;
    };

    const [intervalMinutes, setIntervalMinutes] = useState<number>(() =>
        detectBestInterval(selectedEmployee)
    );

  const [timeMonday, setTimeMonday] = useState<string[]>(
    selectedEmployee.timeMonday
  );
  const [timeTuesday, setTimeTuesday] = useState<string[]>(
    selectedEmployee.timeTuesday
  );
  const [timeWednesday, setTimeWednesday] = useState<string[]>(
    selectedEmployee.timeWednesday
  );
  const [timeThursday, setTimeThursday] = useState<string[]>(
    selectedEmployee.timeThursday
  );
  const [timeFriday, setTimeFriday] = useState<string[]>(
    selectedEmployee.timeFriday
  );
  const [timeSaturday, setTimeSaturday] = useState<string[]>(
    selectedEmployee.timeSaturday
  );
  const [timeSunday, setTimeSunday] = useState<string[]>(
    selectedEmployee.timeSunday
  );

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleEmployeeEdition = async () => {
    setIsLoading(!isLoading);
    try {
      await employeeApi.updateEmployee(selectedEmployee.id, {
        timeMonday,
        timeTuesday,
        timeWednesday,
        timeThursday,
        timeFriday,
        timeSaturday,
        timeSunday,
      });

      window.alert(t("employeesPages.edit.success", { name: selectedEmployee.User.name }));
      navigate("/employees");
    } catch (error) {
      alert(t("employeesPages.edit.error"));
      console.warn("Error editing a employee: ", error);
    }
    setIsLoading(false);
  };

  const renderWorkScaleSelector = (
    <>
      <ComercialInterfaceHeader
        title={
          selectedEmployee.User.id === auth.user.id
            ? t("employeesPages.edit.titleOwn", { store: selectedEmployee.store.name.toUpperCase() })
            : t("employeesPages.edit.titleOther", {
            name: selectedEmployee.User.name,
                store: selectedEmployee.store.name.toUpperCase()
})
        }
      />
      <Box sx={sharedStyles.verticalContent}>
        <WorkingScaleSelector
          intervalMinutes={intervalMinutes}
          setIntervalMinutes={setIntervalMinutes}
          timeMonday={timeMonday}
          setTimeMonday={setTimeMonday}
          timeTuesday={timeTuesday}
          setTimeTuesday={setTimeTuesday}
          timeWednesday={timeWednesday}
          setTimeWednesday={setTimeWednesday}
          timeThursday={timeThursday}
          setTimeThursday={setTimeThursday}
          timeFriday={timeFriday}
          setTimeFriday={setTimeFriday}
          timeSaturday={timeSaturday}
          setTimeSaturday={setTimeSaturday}
          timeSunday={timeSunday}
          setTimeSunday={setTimeSunday}
        />
      </Box>
    </>
  );

  const renderOptionButtons = (
    <Box sx={sharedStyles.dividedFormContainer}>
      <PrimaryButton
        label={t("employeesPages.edit.confirm")}
        onClickAction={handleEmployeeEdition}
        icon={<PersonAddIcon />}
        isLoading={isLoading}
        isDisabled={isLoading}
      />

      <SecondaryButton
        label={t("employeesPages.edit.cancel")}
        isDisabled={isLoading}
        onClickAction={() => navigate("/employees")}
      />
    </Box>
  );
  const renderEditPageContent = (
    <>
      <LeftMarginBackButton />

      <form style={sharedStyles.form}>
        {renderWorkScaleSelector}
        {renderOptionButtons}
      </form>
    </>
  );

  return (
    <Box sx={sharedStyles.sharedMainContainer}>
    <ComercialDrawer content={renderEditPageContent} />
    </Box>
  );
};

export default EditEmployee;
